export default __webpack_public_path__ + "static/media/iphone.589146fc.png";